import queryString from 'query-string';
import { regions_dictionary } from '../../dictionaries/regions_districts_dictionary.js';

export function prepareResults(results) {
  if (!results || results.length === 0) {
    return Object.values(regions_dictionary)
      .filter((region) => region !== '(Пусто)')
      .map((region) => ({ region, value: 0 }));
  }

  const summedByRegion = results.reduce((acc, item) => {
    const { region, value } = item;

    if (!acc[region]) {
      acc[region] = {
        region: region,
        value: 0,
      };
    }

    acc[region].value += Number(value) || 0;

    return acc;
  }, {});

  Object.values(regions_dictionary).forEach((region) => {
    if (region !== '(Пусто)' && !summedByRegion[region]) {
      summedByRegion[region] = { region, value: 0 };
    }
  });

  return Object.values(summedByRegion);

  // if (results.length === 0) {
  //   return [];
  // }
  // const res = {};
  // results.forEach((i) => {
  //   res[i.region] = {
  //     region: i.region,
  //     value: i.value,
  //   };
  // });
  //
  // Object.values(regions_dictionary).forEach((region) => {
  //   if (region !== '(Пусто)' && !res[region]) {
  //     res[region] = { region, value: 0 };
  //   }
  // });
  // results.forEach((i) => {
  //   if (res[i.region]) {
  //     res[i.region].categories[i.category] = i.value;
  //   } else {
  //     res[i.region] = {
  //       region: i.region,
  //       categories: { [i.category]: i.value },
  //     };
  //   }
  // });

  // Object.values(regions_dictionary).forEach((region) => {
  //   if (region !== '(Пусто)' && !res[region]) {
  //     const { categories } = Object.values(res)[0];
  //     res[region] = {
  //       region,
  //       categories: Object.fromEntries(
  //         Object.entries(categories).map(([key]) => [key, 0])
  //       ),
  //     };
  //   }
  // });

  // return Object.values(res);
}

export function checkValue(val) {
  if (val.value.length > 1 && val.value.includes('custom')) {
    return [...val.value, val.custom].filter((i) => i !== 'custom');
  }
  if (val.value.includes('custom') && val.value.length === 1) {
    return [val.custom];
  }
  return val.value;
}

export const formQuery = (data) => {
  const payload = { ...data };
  if (!payload.region_id) delete payload.region_id;
  if (!payload.activeQuarter) {
    delete payload.activeQuarter;
  } else {
    const [year, quarter] = payload.activeQuarter.split('_');
    payload.year = year;
    payload.quarter = quarter;
    delete payload.activeQuarter;
  }
  const result = queryString
    .stringify(payload)
    .replaceAll(/small|medium/g, (match) => {
      if (match === 'small') return 'малый';
      if (match === 'medium') return 'средний';
    });

  return result;
};

export const preparePlanResults = (results) => {
  const temp = {};

  results.forEach((item) => {
    if (!temp[item.region]) {
      temp[item.region] = {
        region: item.region,
        children: [
          {
            region: item.district,
            plan: item.plan,
            plan_regular: item.plan_regular,
            fact: item.value,
            value_priority: item.value_priority,
            value_all: item.value_all,
          },
        ],
      };
    } else {
      temp[item.region].children.push({
        region: item.district,
        plan: item.plan,
        plan_regular: item.plan_regular,
        fact: item.value,
        value_priority: item.value_priority,
        value_all: item.value_all,
      });
    }
  });
  return Object.values(temp).map((item) => {
    return {
      key: `plan-${item.region}`,
      region: item.region,
      plan: item.children.reduce((a, b) => a + (b.plan ?? 0), 0),
      plan_regular: item.children.reduce(
        (a, b) => a + (b.plan_regular ?? 0),
        0
      ),
      fact: item.children.reduce((a, b) => a + (b.fact ?? 0), 0),
      value_priority: item.children.reduce(
        (a, b) => a + (b.value_priority ?? 0),
        0
      ),
      value_all: item.children.reduce((a, b) => a + (b.value_all ?? 0), 0),
      children: item.children,
    };
  });
};
